// extracted by mini-css-extract-plugin
export default {"active":"resourceDropdown_active__d9+mz","activeBackground":"resourceDropdown_activeBackground__NTe5o"};